import PlusIcon from '@material-ui/icons/AddSharp';
import FlagIcon from '@material-ui/icons/FlagSharp';
import PlayIcon from '@material-ui/icons/PlayArrowSharp';
import RestartIcon from '@material-ui/icons/ReplaySharp';
import SaveIcon from '@material-ui/icons/SaveSharp';
import StopIcon from '@material-ui/icons/StopSharp';
import * as React from 'react';
export default {
  PlusIcon,
  FlagIcon,
  PlayIcon,
  RestartIcon,
  SaveIcon,
  StopIcon,
  React
};